import { sum } from 'es-toolkit';
import type { AiSerializedMessage } from 'juneau';

/** UTF-8 budget of a saved history, under the API's 1 MiB `MAX_REQUEST_BODY_SIZE_BYTES`. */
export const PERSISTED_HISTORY_MAX_BYTES = 800_000;

const encoder = new TextEncoder();

/**
 * Drops the oldest messages until the history's JSON fits `maxBytes`, never leaving an assistant
 * message first. Empty when even the newest exchange does not fit.
 */
export function fitHistoryToByteBudget(
  messages: AiSerializedMessage[],
  maxBytes: number = PERSISTED_HISTORY_MAX_BYTES
): AiSerializedMessage[] {
  const sizes = messages.map(message => encoder.encode(JSON.stringify(message)).length);
  // The array's own JSON: two brackets and a comma between messages.
  let bytes = 2 + sum(sizes) + Math.max(messages.length - 1, 0);
  let start = 0;
  while (
    start < messages.length &&
    (bytes > maxBytes || (start > 0 && messages[start].role === 'assistant'))
  ) {
    bytes -= sizes[start] + 1;
    start++;
  }
  return start === 0 ? messages : messages.slice(start);
}
